import { inject, ComponentEventBus, prop, needs } from "fw";

import { SearchType } from "state/search";
import { AtsOrganization } from "models/ats-organization";
import { AtsUser } from "models/ats-user";

import { PanelUsers } from "./panel-users";
import { PanelOrganizations } from "./panel-organizations";

@inject
@needs(PanelUsers, PanelOrganizations)
export class SearchItemModal {
    @prop(null) type: SearchType;
    @prop(null) data: AtsUser | AtsOrganization;

    constructor(private ceb: ComponentEventBus) {}

    close() {
        this.ceb.dispatch("close");
    }

    async attached() {}

    get headerText() {
        switch (this.type) {
            case SearchType.Users:
                return "User Detail";
            case SearchType.Organizations:
                return "Organization Detail";
            default:
                return "";
        }
    }

    get name() {
        let data = null;
        switch (this.type) {
            case SearchType.Users:
                data = this.data as AtsUser;
                return data.FirstName + " " + data.LastName;
            case SearchType.Organizations:
                data = this.data as AtsOrganization;
                return data.Name;
            default:
                return "";
        }
    }
}
